<template>
  <div class="image-box">
    <div class="image-box-preview">
      <v-img v-if="localImagePreview" :src="localImagePreview" />
      <svg-icon v-else icon="image-empty" width="100" height="100" />
    </div>
    <template v-if="withUpload">
      <v-btn color="primary btn-primary-custom" class="mt-4" block @click="uploadFile">{{ uploadBtnText }}</v-btn>
    </template>
    <input type="file" ref="fileInput" accept="image/*" class="image-box-file" @change="getFileAndPreview" />
    <div v-if="error" class="mt-3 red--text">{{ error }}</div>
  </div>
</template>

<script>
export default {
  name: 'ImageBox',
  model: {
    event: 'change'
  },
  props: {
    value: {
      default: null
    },
    imagePreview: {
      type: String,
      default: ''
    },
    withUpload: {
      type: Boolean,
      default: false
    },
    uploadBtnText: {
      type: String,
      default: 'Upload'
    },
    errorMessages: {
      type: [String, Array]
    }
  },
  computed: {
    error() {
      return this.errorMessage ? this.$t(this.errorMessage) : this.errorMessages?.[0];
    }
  },
  data: () => ({
    localImagePreview: null,
    errorMessage: ''
  }),
  methods: {
    uploadFile() {
      this.$refs.fileInput.click();
    },
    getFileAndPreview(e) {
      const [file] = e.target.files;

      if (!file) return;

      const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
      const fileType = file.type;

      if (!fileType || !allowedTypes.includes(fileType)) {
        this.errorMessage = 'validations.file.image';
        e.target.value = null;
        this.localImagePreview = '';
        this.$emit('change', null);
        return;
      }

      const maxSize = 1 * 1024 * 1024;

      if (file.size > maxSize) {
        this.errorMessage = 'validations.file.maxImageSize';
        e.target.value = null;
        this.localImagePreview = '';
        this.$emit('change', null);
        return;
      }

      this.errorMessage = '';
      this.localImagePreview = URL.createObjectURL(file);
      this.$emit('change', file);
    }
  },
  watch: {
    imagePreview(newVal) {
      this.localImagePreview = newVal;
    }
  },
  created() {
    this.localImagePreview = this.imagePreview;
  }
};
</script>

<style lang="scss" scoped>
.image-box {
  position: relative;

  &-preview {
    width: 245px;
    height: 198px;
    background: #fff;
    background-color: #f2f2f2;
    border: 1px solid #979797;
    box-sizing: border-box;
    border-radius: 4px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto;
  }

  &-file {
    width: 0;
    display: none;
  }
}
</style>
